import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';

@Pipe({
  name: 'timezone'
})
export class TimezonePipe implements PipeTransform {

  /**
   * Konvertiert einen Zeitwert in die angegebene Zeitzone.
   * Der Eingabewert wird als UTC interpretiert und dann in die Zielzeitzone konvertiert.
   */
  transform(value: unknown, timezone: string = 'Europe/Berlin'): moment.Moment | null {
    if (!value) {
      return null;
    }
    // moment(value).tz(timezone) konvertiert den UTC-Wert in die Zielzeitzone
    return moment(value).tz(timezone);
  }

}
